import { createSlice } from "@reduxjs/toolkit";
import { save } from "./save";
import { empty } from "./empty";

export interface Storage {
  value: string;
  key: number;
}

const initialState: Storage[] = JSON.parse(
  localStorage.getItem("current") ?? "[]"
);

export const slice = createSlice({
  initialState,
  name: "storage",
  reducers: {
    save,
    empty,
    update(state, { payload }) {
      const { index, value } = payload;
      state[index].value = value;
    },

    remove(state, { payload: index }) {
      !!state[index] && state.splice(index, 1);
    },

    append(state, { payload: value }) {
      state.push({ value, key: Math.random() });
      save(state, { payload: "current" });
    },

    load(state, { payload: label }) {
      empty(state);

      localStorage.getItem(label) &&
        state.push(...JSON.parse(localStorage.getItem(label)!));
    },
  },
});

export const reducer = slice.reducer;

export const actions = slice.actions;
